export const iconFontAwesomeShoppingCcAmazonPay = (
	<i className="fa-solid fa-cc-amazon-pay"></i>
);
